<script setup>
// // Component imports
import BarcodeQr from '@/components/BarcodeQr/BarcodeQrComp.vue';
import Transaction from '@/components/Transaction/TransactionComp.vue';

// // Store management imports
import { useBreakStore } from '@/stores/break';

const storeBreak = useBreakStore();

const props = defineProps({
  goodsData: {
    type: Array,
    // required: true,
    default: () => [
      {
        productUuid: '',
        productSku: '',
        productUrl: '',
        productImages: [
          {
            productImageSrc: '',
            // productImageWidth: '',
            // productImageHeight: '',
          },
        ],
        productName: '',
        productPosition: 1,
      },
    ],
  },
  interactiveBreakUuid: {
    type: String,
    required: true,
  },
  adId: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div v-for="item in props.goodsData" :key="item.productPosition" class="poll-goods">
    <BarcodeQr
      v-if="!storeBreak.hasProductBeenPurchased"
      class="poll-goods__qr"
      :barcode-foreground-color="'#000000'"
      :target-url="item.productUrl"
      :interactive-break-uuid="props.interactiveBreakUuid"
      :product-uuid="item.productUuid"
      :ad-id="props.adId"
    />

    <div v-if="!storeBreak.hasProductBeenPurchased" class="poll-goods__info">
      <span class="poll-goods__name">{{ item.productName }}</span>
    </div>
  </div>

  <Transaction :interactive-break-uuid="props.interactiveBreakUuid" />
</template>
